module.exports = __webpack_public_path__ + "static/media/happiness-icon-positive.2bbb5ff4.svg";